import { IconDefinition } from "@fortawesome/duotone-regular-svg-icons";
import { faCabin } from "@fortawesome/duotone-regular-svg-icons/faCabin";
import { faCampfire } from "@fortawesome/duotone-regular-svg-icons/faCampfire";
import { faCaravan } from "@fortawesome/duotone-regular-svg-icons/faCaravan";
import { faFaucetDrip } from "@fortawesome/duotone-regular-svg-icons/faFaucetDrip";
import { faGrill } from "@fortawesome/duotone-regular-svg-icons/faGrill";
import { faPersonSwimming } from "@fortawesome/duotone-regular-svg-icons/faPersonSwimming";
import { faPhone } from "@fortawesome/duotone-regular-svg-icons/faPhone";
import { faPoo } from "@fortawesome/duotone-regular-svg-icons/faPoo";
import { faRv } from "@fortawesome/duotone-regular-svg-icons/faRv";
import { faShower } from "@fortawesome/duotone-regular-svg-icons/faShower";
import { faTablePicnic } from "@fortawesome/duotone-regular-svg-icons/faTablePicnic";
import { faTent } from "@fortawesome/duotone-regular-svg-icons/faTent";
import { faToilet } from "@fortawesome/duotone-regular-svg-icons/faToilet";
import { faWashingMachine } from "@fortawesome/duotone-regular-svg-icons/faWashingMachine";

interface IconMapEntry {
  icon: IconDefinition;
  tooltip: string;
  color_if_yes?: string;
  color_if_no?: string;
}

export const TAGS_TO_ICONS: Record<string, IconMapEntry> = {
  bbq: {
    icon: faGrill,
    tooltip: "BBQ available",
  },
  cabins: {
    icon: faCabin,
    tooltip: "cabins available",
  },
  caravans: {
    icon: faCaravan,
    tooltip: "trailers/caravans allowed",
  },
  drinking_water: {
    icon: faFaucetDrip,
    tooltip: "drinking water available",
  },
  firepit: {
    icon: faCampfire,
    tooltip: "firepit available",
  },
  motorhome: {
    icon: faRv,
    tooltip: "motorhomes allowed",
  },
  picnic_table: {
    icon: faTablePicnic,
    tooltip: "picnic table available",
  },
  sanitary_dump_station: {
    icon: faPoo,
    tooltip: "sanitary dump station available",
  },
  shower: {
    icon: faShower,
    tooltip: "showers available",
  },
  swimming_pool: {
    icon: faPersonSwimming,
    tooltip: "swimming pool available",
  },
  telephone: {
    icon: faPhone,
    tooltip: "public telephone available",
  },
  tents: {
    icon: faTent,
    tooltip: "tents allowed",
  },
  toilets: {
    icon: faToilet,
    tooltip: "toilets available",
  },
  washing_machine: {
    icon: faWashingMachine,
    tooltip: "washing machine available",
  },
  // List should be kept up-to-date with campgrounds.lua
};
